import { Card, formattedCurrency, withStyles } from 'vopay';
import { Title, DetailsRows } from 'UI';
import { useTranslation } from 'react-i18next';
import type { UserRoles } from 'vopay';
import styleSheet from './ApproverCard.module.scss';

const cn = withStyles(styleSheet);

interface ApproverCardProps {
  username: string;
  paymentRails: UserRoles[];
}

const ApproverCard = ({ username, paymentRails }: ApproverCardProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Configuration.Roles.Approvers' });

  const details = paymentRails.map((rail) => ({
    label: rail.TransactionType,
    value: rail.MaxAmount ? `${formattedCurrency(rail.MaxAmount)}` : t('noLimit', { defaultValue: 'No Limit' }),
  }));

  return (
    <Card className={cn('card')} hoverEffect={false}>
      <Title level="5" className={cn('username')}>
        {username}
      </Title>
      <div className={cn('railsHeader')}>
        <Title level="6">{t('paymentRailsLabel', { defaultValue: 'Payment Rails' })}</Title>
        <Title level="6">{t('maximumApprovalAmountLabel', { defaultValue: 'Maximum Approval Amount' })}</Title>
      </div>
      <DetailsRows details={details} />
    </Card>
  );
};

export default ApproverCard;
